import { useGetUsersQuery, UserSource } from 'data/__generated__';

import { DataTable } from 'components/DataTable';

import { usersColumns, type UserRow, type UsersFilterInput } from '../constants/usersColumns';

const defaultFilters: UsersFilterInput = {
    sources: [UserSource.Totem],
};

export const UserList = () => {
    const {
        loading: usersLoading,
        data: usersData,
        error: usersError,
        refetch,
        fetchMore,
    } = useGetUsersQuery({
        variables: { offset: 0, filters: defaultFilters },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    if (usersError) {
        throw new Error('Une erreur est survenue lors de la récupération des users');
    }

    const hasMore = usersData?.users.hasMore ?? false;
    const users = usersData?.users.users ?? [];

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<UserRow, UsersFilterInput>
                columns={usersColumns}
                data={users}
                filterMode="server"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/user/${row._id}`}
                hasMore={hasMore}
                isLoading={usersLoading}
                refetch={async (vars) => {
                    await refetch({ ...vars, offset: 0 });
                }}
                fetchMore={async (opts) => {
                    await fetchMore({
                        variables: { ...opts.variables, offset: opts.variables.offset ?? users.length },
                    });
                }}
                defaultFilters={defaultFilters}
                searchPlaceholder="Email, nom, nickname ou id de l'utilisateur"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
